import { useMemo, useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { logRecommendation } from "../../state/actions/agentActions";
import {
  RECOMMENDATION_LABELS,
  DEFAULT_RECOMMENDATION_FIELDS,
} from "../../utils/propertyConstants";

const Recommend = ({
  fields = DEFAULT_RECOMMENDATION_FIELDS,
  agentId,
  propertyId,
  codeId,
  type,
  recommends = [],
  styles,
}) => {
  const dispatch = useDispatch();

  const [pendingRecommends, setPendingRecommends] = useState(new Set());

  const isPending = useCallback(
    (id) => recommends.includes(id) || pendingRecommends.has(id),
    [recommends, pendingRecommends]
  );

  const handleSubmit = useCallback(
    (value, valueChange) => {
      setPendingRecommends((prev) => {
        const next = new Set(prev);
        next.add(value);
        return next;
      });
      dispatch(
        logRecommendation({
          propertyId,
          codeId,
          agentId,
          data: { [value]: valueChange },
        })
      );
      toast.success(
        `Predlog o promeni ${RECOMMENDATION_LABELS[value]} je poslat`
      );
    },
    [dispatch, propertyId, codeId, agentId]
  );

  const { trueFields, falseFields } = useMemo(() => {
    const filteredFields =
      type !== "stan"
        ? Object.fromEntries(
            Object.entries(fields).filter(([key]) => key !== "top_studio")
          )
        : fields;

    return Object.entries(filteredFields).reduce(
      (acc, [key, value]) => {
        if (value) {
          acc.trueFields.push({ id: key, value });
        } else {
          acc.falseFields.push({ id: key, value });
        }
        return acc;
      },
      { trueFields: [], falseFields: [] }
    );
  }, [fields, type]);

  return (
    <div key={`recommend-container`} className={styles.recommendContainer}>
      <div key={`recommend-box1`} className={styles.box1}>
        <div key={`recommend-recommend-to-remove-from`} className={styles.text}>
          Preporuči da se nekretnina skloni iz:
        </div>
        <div
          key={`recommend-subcontainer`}
          style={{ alignItems: "center", display: "flex" }}
        >
          {trueFields.map((item, index) => (
            <button
              key={`recommend-button-remove-from-${index}`}
              type="button"
              className={styles.button}
              style={{ padding: "0px" }}
              disabled={isPending(item.id)}
              onClick={() => handleSubmit(item.id, false)}
            >
              {RECOMMENDATION_LABELS[item.id]}
            </button>
          ))}
        </div>
      </div>
      <div key={`recommend-box2`} className={styles.box2}>
        <div key={`recommend-recommend-add-to`} className={styles.text}>
          Preporuči da se nekretnina doda u:
        </div>
        <div
          key={`recommend-subcontainer`}
          style={{ alignItems: "center", display: "flex" }}
        >
          {falseFields.map((item, index) => (
            <button
              key={`recommend-button-add-to-${index}`}
              type="button"
              className={styles.button2}
              style={{ padding: "0px" }}
              disabled={isPending(item.id)}
              onClick={() => handleSubmit(item.id, true)}
            >
              {RECOMMENDATION_LABELS[item.id]}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Recommend;
